import { v4 as uuidv4 } from 'uuid';

export function SellerName(props = {}, childrenComponents = []) {
	return {
		componentName: 'SellerName',
		componentId: uuidv4(),
		title: '',
		props: Object.assign({}, props),
		childrenComponents,
	};
}
